import * as React from "react";
const SvgAsteriskIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 8, height: 8, viewBox: "0 0 8 8", xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("g", { transform: "matrix(1 0 0 1 3.26 3.13)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", style: {
  stroke: "none",
  strokeWidth: 1,
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fillRule: "nonzero",
  opacity: 1
}, transform: " translate(-122.8, -3.55)", d: "M 120.478 2.103 L 120.037 3.447 L 121.71 3.958 L 120.66 5.351 L 121.801 6.184 L 122.802 4.749 L 123.81 6.184 L 124.951 5.351 L 123.894 3.958 L 125.567 3.447 L 125.133 2.103 L 123.474 2.677 L 123.509 0.92 H 122.102 L 122.13 2.677 L 120.478 2.103 Z", strokeLinecap: "round" })));
export default SvgAsteriskIcon;
